module.exports = __webpack_public_path__ + "static/media/german_correa_p.4209136a.jpg";